import template from './sync-runhours.html';
import { RunHourStatus, StatusMessages } from './sync-runhours.model';

import modalTemplate from './confirm-modal/sync-confirm.modal.html';
import ModalController from './confirm-modal/sync-confirm.modal';

const dataLayer = window.dataLayer || [];

const gtmEvents = {
  deviceSetRunHours: 'deviceSetRunHours',
};

class SyncRunHoursController {
  constructor(syncRunHoursService, $uibModal, gettextCatalog) {
    'ngInject';

    this.syncRunHoursService = syncRunHoursService;
    this.$uibModal = $uibModal;
    this.setSyncStatus();
    this.messages = StatusMessages;
    this.gettextCatalog = gettextCatalog;
  }

  setSyncStatus(status = '', message = '', info = '', iclass = '') {
    if (status === RunHourStatus.NOT_REPORTED) {
      this.notcommStatus = {
        status,
        message,
        info,
      };
    } else {
      this.syncStatus = {
        status,
        message,
        info,
        iclass,
      };
    }
  }

  $onInit() {
    // get reported series if not provided
    if (!this.runhoursSeries) {
      this.getReportedRunHours();
    }
  }

  setRunHours(runhoursValue) {
    if (runhoursValue >= 0) {
      this.setSyncStatus(
        RunHourStatus.UPDATING,
        this.messages.UPDATING,
        '',
        'fa fa-spinner fa-pulse',
      );

      dataLayer.push({
        event: gtmEvents.deviceSetRunHours,
        data: {
          installationId: this.installationId,
          datapointId: this.datapointId,
        },
      });

      this.syncRunHoursService
        .syncRunHours(this.installationId, this.datapointId, runhoursValue)
        .then(() => {
          this.setSyncStatus(RunHourStatus.SUCCESS, this.messages.SUCCESS);
        })
        .catch(() => {
          this.setSyncStatus(RunHourStatus.ERROR, this.messages.ERROR);
        });
    }
  }

  getReportedRunHours() {
    if (this.equipmentId) {
      this.loading = true;
      this.syncRunHoursService
        .getLastReportedRunHours(this.equipmentId, this.datapointId)
        .then((response) => {
          const [first] = response.data;
          this.runhoursSeries = first;
          if (!this.runhoursSeries || !this.runhoursSeries.last) {
            this.setSyncStatus(
              RunHourStatus.NOT_REPORTED,
              this.messages.NOT_REPORTED,
              this.messages.NOT_REPORTED_Not_M5,
            );
          }
        })
        .catch(() => this.setSyncStatus(RunHourStatus.ERROR, this.messages.GET_RUNHOURS_ERROR))
        .finally(() => {
          this.loading = false;
        });
    }
  }

  //* ************************ modal *************************
  openConfirmationModal(syncValue) {
    if (syncValue >= 0) {
      this.$uibModal
        .open({
          animation: true,
          size: 'md',
          template: modalTemplate,
          controller: ModalController,
          controllerAs: 'modalVm',
          resolve: {
            syncValue: () => syncValue,
            datapointName: () =>
              this.runhoursSeries && this.runhoursSeries.title
                ? this.gettextCatalog.getString(this.runhoursSeries.title)
                : this.gettextCatalog.getString('Run Hours'),
          },
        })
        .result.then(() => {
          // do the sync
          this.setRunHours(syncValue);
        })
        .catch(() => {});
    }
  }
}

const SyncRunHoursComponent = {
  template,
  controller: SyncRunHoursController,
  controllerAs: 'vm',
  bindings: {
    next: '&',
    equipmentId: '<',
    installationId: '<',
    pageClass: '<',
    deviceModel: '<',
    datapointId: '<',
    runhoursSeries: '<',
  },
};

export default SyncRunHoursComponent;
